module.exports = __webpack_public_path__ + "img/grosshoehenrain_austtattung_2018_ref.f96a1639.jpg";